import React from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Typography,
  Box,
} from "@mui/material";

export default function CoinsWinnersTicker({ config, onChange }) {
  const updateDisplay = (key, value) => {
    onChange({
      ...config,
      display: { ...config.display, [key]: value },
    });
  };

  const updateCategories = (key, value) => {
    onChange({
      ...config,
      categories: { ...config.categories, [key]: value },
    });
  };

  const updateMinAmount = (value) => {
    onChange({ ...config, minAmount: value });
  };

  const updateQuantityLimit = (value) => {
    onChange({ ...config, quantityLimit: value });
  };

  return (
    <Box display="flex" flexDirection="column" gap={4}>
      <div>
        <Typography variant="subtitle2" gutterBottom>
          Display
        </Typography>
        <FormGroup row>
          {Object.entries(config.display).map(([key, value]) => (
            <FormControlLabel
              key={key}
              control={
                <Checkbox
                  checked={value}
                  onChange={(e) => updateDisplay(key, e.target.checked)}
                />
              }
              label={capitalize(key)}
            />
          ))}
        </FormGroup>
      </div>

      {/* Categories Section */}
      <div>
        <Typography variant="subtitle2" gutterBottom>
          Categories
        </Typography>
        <FormGroup row>
          {Object.entries(config.categories).map(([key, value]) => (
            <FormControlLabel
              key={key}
              control={
                <Checkbox
                  checked={value}
                  onChange={(e) => updateCategories(key, e.target.checked)}
                />
              }
              label={formatLabel(key)}
            />
          ))}
        </FormGroup>
      </div>

      <Box display="flex" sx={{ display: "flex", alignItems: "end" }} gap={4}>
        <FormControl>
          <Typography variant="subtitle2" gutterBottom>
            Min Amount
          </Typography>
          <TextField
            type="number"
            value={config.minAmount}
            onChange={(e) => updateMinAmount(Number(e.target.value))}
            InputProps={{
              startAdornment: (
                <img
                  src="/assets/icons/ufcoin.svg"
                  alt="dollar"
                  style={{ width: 20, height: 20, marginRight: 20 }}
                />
              ),
              style: { borderRadius: "20px", width: "150px" },
            }}
            size="small"
          />
        </FormControl>

        <FormControl size="small">
          <InputLabel>Quantity Limit</InputLabel>
          <Select
            value={config.quantityLimit}
            label="Quantity Limit"
            onChange={(e) => updateQuantityLimit(e.target.value)}
            style={{ width: 150 }}
          >
            {["10", "20", "50", "100"].map((item) => (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
}

function formatLabel(label) {
  return label
    .replace(/([A-Z])/g, " $1")
    .replace(/^uf/, "UF")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
